module.exports = __webpack_public_path__ + "img/login_img.88af6b7c.png";